"use client"

import { useEffect, useState } from "react"
import useLocaleStore from "@/app/stores/useLocaleStore"
import JobBoardBanner from "../organisms/JobBoardBanner"
import { JobBoard } from "../organisms/JobList"
import { ReactQueryProvider } from "@/contexts/QueryProvider"
import { getMessages } from "@/app/utils/getTranslation"
import LoadingGear from "../molecules/Loader"

export function JobListingPage() {
  const [translations, setTranslations] = useState<Record<string, any> | null>(null)

  const locale = useLocaleStore((state) => state.locale)

  useEffect(() => {
    const fetchMessages = async () => {
      const data = await getMessages(locale, "job")
      setTranslations(data)
    }
    fetchMessages()
  }, [locale])

  if (!translations) return <LoadingGear />

  return (
    <ReactQueryProvider>
      <JobBoardBanner translations={translations.jobBoardBanner} />
      <JobBoard translations={translations.jobBoard} />
    </ReactQueryProvider>
  )
}
